import { defineComponent } from 'vue';
import Image from '@hems/component/src/image/Image2.vue';
export default defineComponent({
    name: 'IconButton',
    components: {
        Image,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        src: {
            type: String,
            default: '',
        },
        extension: {
            type: String,
            default: 'svg',
        },
    },
});
